/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { bool, func } from 'prop-types';
import customBreakpoints from '../../../../helpers/customBreakpoints';

const useStyles = makeStyles((theme) => ({
    button: {
        background: theme.palette.colorPrimary,
        color: 'white',
    },
    outerWrapper: {
        padding: '25px',
    },
    text: {
        fontSize: '15px',
    },
    textWrapper: {
        marginBottom: '15px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginBottom: '30px',
        },
    },
    buttonWrapper: {
        position: 'absolute',
        right: '5px',
        bottom: '5px',
    },
}));

const CovidWarningPopup = ({ isOpen, closeModal }) => {
    const classes = useStyles();
    return (
        <Dialog open={isOpen} className={classes.outerDialog} data-testid="covid-dialog">
            <Grid container className={classes.outerWrapper}>
                <Grid item className={classes.textWrapper}>
                    <Typography className={classes.text}>
                        <b>Please be advised:</b> Deliveries to non-residential addresses, like <b>hospitals</b> and <b>schools</b>, may be impacted by local health and safety restrictions due to the current <b>COVID-19</b> pandemic. Please consider selecting an alternative address. We will continue to monitor this closely and will be in touch with you if we cannot deliver your gift.
                    </Typography>
                </Grid>
                <Grid item className={classes.buttonWrapper}>
                    <Button variant="contained" className={classes.button} onClick={() => { closeModal(); }}>
                        Ok
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
};

CovidWarningPopup.propTypes = {
    isOpen: bool.isRequired,
    closeModal: func.isRequired,
};

export default CovidWarningPopup;
